module.exports = __webpack_public_path__ + "img/nature-24.5e2b4799.jpg";